// extracted by mini-css-extract-plugin
module.exports = {"container":"top-banner_container__VbckJ","link":"top-banner_link__btc_6","spinner":"top-banner_spinner__XXZRj","fade-in":"top-banner_fade-in__YmF62"};